import {
    GET_ALL_MONTH_WISE_AVAILABILITY_REPORT_REQUEST,
    GET_ALL_MONTH_WISE_AVAILABILITY_REPORT_SUCCESS,
    GET_ALL_MONTH_WISE_AVAILABILITY_REPORT_ERROR,
} from "../actions/types";

export const monthWiseAvailability = (state = [], action) => {
    const { type, payload } = action;
    switch (type) {
        case GET_ALL_MONTH_WISE_AVAILABILITY_REPORT_REQUEST:
            return {
                loading: true,
            };
        case GET_ALL_MONTH_WISE_AVAILABILITY_REPORT_SUCCESS:
            return {
                ...state,
                loading: false,
                payload,
            };
        case GET_ALL_MONTH_WISE_AVAILABILITY_REPORT_ERROR:
            return {
                ...state,
                loading: false,
                payload,
            };

        default: {
            return state;
        }
    }
};
